export default __webpack_public_path__ + "static/media/Thug's Gloves of Malice.5342c235.jpg";